var _defs;
import * as React from "react";
function SvgUnl(props) {
  return /*#__PURE__*/React.createElement("svg", props, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "UNL_svg__UniversRegular",
    horizAdvX: 556
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Univers",
    fontWeight: 5,
    ascent: 800,
    descent: -200,
    xHeight: 502,
    capHeight: 725,
    bbox: "-151 -250 1000 957",
    underlineThickness: 50,
    underlinePosition: -75,
    unicodeRange: "U+0020-F002"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 790,
    d: "M49 0v790h692V0H49zm643 49v692H98V49h594z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 278
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    horizAdvX: 278
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 389,
    d: "M167 171l-13 551h82l-13-551h-56zm68-85V0h-80v86h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 278,
    d: "M58 722h52V496H58v226zm110 0h52V496h-52v226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    d: "M226 423l-22-137h137l20 137H226zm301 0H420l-20-137h101v-60H391L360 0h-59l31 226H196L162 0h-58l34 226H29v60h118l20 137H56v60h119l32 209h59l-31-209h135l30 209h59l-31-209h99v-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    d: "M301 45q56 0 100 36t44 95q0 57-36.5 82.5T301 309V45zm0-113h-50v53q-86 0-147.5 49T42 176h70q0-65 38.5-98T251 45v275q-115 49-155.5 75T55 515q0 78 61 135t135 57v48h50v-48q80 0 141-47.5T503 532h-70q0 59-40 88t-92 29V374q76-24 116-42t69-55.5T515 174q0-92-63.5-140.5T301-15v-53zm-50 715q-51 0-88.5-36.5T125 516q0-41 26-72.5T251 389v258z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 1000,
    d: "M173 518q0-58 25-101t79-43q53 0 78.5 43T381 518t-25 101-79 43q-53 0-78.5-43T173 518zm538 189L321 0h-58l390 707h58zM436 518q0-79-42.5-134T277 329q-73 0-116 55.5T118 518q0 79 42.5 134T277 707q73 0 116-55.5T436 518zm446-344q0-79-42.5-134T723-15q-73 0-116 55.5T564 174q0 79 42.5 134T723 363q73 0 116-55.5T882 174zm-263 0q0-58 25-101t79-43q53 0 78.5 43T827 174t-25 101-79 43q-53 0-78.5-43T619 174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 722,
    d: "M275 381q-55-36-103-82t-48-87q0-76 55-121.5T312 45q57 0 101.5 23.5T501 138zm113 224q0 35-26 53.5T300 677q-39 0-65-17.5T209 605q0-36 21.5-71t56.5-73q33 31 66 63 35 40 35 81zM234 426q-47 54-71 93t-24 87q0 63 46.5 97T297 737q66 0 113.5-32.5T458 609q0-58-34.5-100T326 419l211-225q23 51 34.5 126.5T583 461h70q-15-155-28-207t-44-105L718 0h-93l-86 96q-46-55-99.5-83T318-15q-113 0-188.5 58T54 198q0 87 54.5 133.5T230 422z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 278,
    d: "M113 722h52V496h-52v226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 278,
    d: "M183-96Q122 68 99 143T76 313q0 68 14 132t34 120 60 157h50q-42-106-65-209.5T146 313q0-98 24-202t64-207h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 278,
    d: "M44-96q38 97 63 205t25 204q0 94-23 198.5T44 722h50q32-82 55-146t38-131.5T202 313q0-94-23.5-171.5T95-96H44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    d: "M279 586l67 136 51-28-88-127 143 12v-58l-142 11 86-129-52-27-65 138-68-140-50 29 87 128-144-10v58l145-12-91 126 53 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 660,
    d: "M300 502h60V281h220v-60H360V0h-60v221H80v60h220v221z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 278,
    d: "M183 81l-72-205H59l43 205h81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 278,
    d: "M13 297h252v-60H13v60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 278,
    d: "M99 0v86h80V0H99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 278,
    d: "M236 722h65L40-96h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    d: "M118 346q0-119 31.5-210T278 45q96 0 128 92t32 209q0 119-31.5 210T278 647q-96 0-128-92t-32-209zm390 0q0-157-50.5-259T278-15 98.5 86.5 48 346q0 157 50.5 259T278 707t179.5-101.5T508 346z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    d: "M116 583q45 18 83 44.5t76 64.5h62V0h-65v622q-31-30-71-56t-85-48v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    d: "M50 0v68q73 65 152 146t141.5 167T406 524q0 59-39.5 91T267 647q-62 0-101-38t-39-100H57q0 90 60 144t152 54q89 0 148-46t59-133q0-74-57.5-157.5T279 206.5 128 60h357V0H50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    d: "M225 392q10-1 17.5-1.5t12.5-.5q66 0 113.5 33.5T416 522q0 57-45 91t-108 34q-66 0-105-33t-46-93H42q0 84 62.5 135T254 707q97 0 164.5-47T486 518q0-61-40-102t-101-54q69-16 110.5-62.5T497 185q0-92-71-146T260-15q-98 0-163 51.5T32 183h70q0-62 46.5-100T259 45q73 0 120.5 38T427 193q0 67-48.5 103T263 332q-20 0-38-3v63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    d: "M347 161H22v63l304 468h86V215h111v-54H412V0h-65v161zm0 466L77 215h270v412z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    d: "M92 692h381v-60H154l-11-247 2-2q30 34 68.5 53.5T297 456q94 0 152.5-67.5T508 225q0-103-60.5-171.5T286-15q-96 0-160 46T62 170h70q0-60 42-92.5T279 45q77 0 118 51.5T438 228q0 77-39.5 122.5T283 396q-50 0-90-29t-50-76H76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    d: "M127 211q0-67 44.5-116.5T283 45q75 0 116.5 47.5T441 216t-36 127-109 51q-80 0-124.5-51.5T127 211zm375 319h-70q0 52-38.5 84.5T300 647q-111 0-148-89t-37-222q24 55 72.5 84T299 449q99 0 155.5-63.5T511 220 452 51.5 293-15q-134 0-191 91.5T45 311q0 110 18 195t73.5 143T297 707q90 0 147.5-45T502 530z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    d: "M492 634L223 0h-76l277 632H51v60h441v-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    d: "M443 188q0 70-48 106.5T278 331q-71 0-118-36t-47-107q0-70 48-106.5T278 45q71 0 118 36t47 107zM118 521q0-63 44-96.5T278 391t116 33.5 44 96.5q0 64-47.5 97.5T278 652t-112.5-32.5T118 521zm-65 0q0 90 66.5 138T278 707q91 0 158-48t67-138q0-61-38.5-103.5T364 361v-1q72-19 110.5-61.5T513 188q0-98-69.5-150.5T278-15q-95 0-165 52T43 188q0 67 40.5 111.5T194 359q-61 7-101 53.5T53 521z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    d: "M115 476q0-69 40-112t108-43q72 0 119.5 46.5T430 485t-45.5 116.5T267 647q-74 0-113-47.5T115 476zm2-306q0-64 41-94.5T267 45q104 0 139.5 102T442 372q-27-50-76-78t-109-28q-93 0-152.5 60.5T45 481q0 100 61 163t160 63q138 0 192-95.5T512 365q0-169-55.5-274.5T249-15q-92 0-147 51T47 170h70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 278,
    d: "M179 502v-86H99v86h80zm0-416V0H99v86h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 278,
    d: "M202 81l-72-205H78l43 205h81zm-15 421v-86h-80v86h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 660,
    d: "M580 54v-64L80 225v53l500 223v-64L159 251z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 660,
    d: "M580 318H80v60h500v-60zm0-194H80v60h500v-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 660,
    d: "M80 448v64l500-235v-53L80 1v64l421 186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 500,
    d: "M174 169v108q0 38 46 83.5t91 88.5q49 55 49 107 0 65-45.5 93T198 677q-24 0-46.5-4T104 662v61q25 8 52 11t58 3q92 0 151.5-45.5T425 558q0-67-30-104t-73-79-65.5-65.5T234 253v-84h-60zm70-83V0h-80v86h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 800,
    d: "M334 196q63 0 113.5 90.5T498 454q0 29-19 50t-49 21q-74 0-123.5-78.5T257 290q0-39 20.5-66.5T334 196zm220 370h66L520 266q-12-34-12-51 0-26 29-26 59 0 108 77.5T694 427q0 117-81.5 188.5T414 687q-136 0-225-96t-89-234q0-135 91.5-228.5T416 35q78 0 148 35.5T679 170h58Q691 85 603.5 35T416-15Q257-15 148.5 95.5T40 364q0 154 109.5 263.5T412 737q144 0 243-89t99-224q0-115-73.5-202.5T523 134q-29 0-53 13t-32 39q-23-23-54.5-36.5T319 136q-62 0-99.5 42.5T182 285q0 108 71 204t175 96q36 0 66-16.5t45-48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 667,
    d: "M488 255L332 662 173 255h315zM9 0l286 722h76L659 0h-71l-77 195H152L76 0H9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 667,
    d: "M165 60h159q99 0 147.5 31T520 202q0 85-59 113.5T285 344H165V60zm157 344q72 0 120 31t48 100q0 72-47 99.5T319 662H165V404h157zM100 0v722l259-1q84 0 142.5-48.5T560 541q0-60-37.5-104.5T426 378q76-14 120-61.5T590 193q0-80-52.5-136.5T375 0H100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 667,
    d: "M542 553q-9 63-55.5 93.5T372 677q-127 0-184-92.5T131 361q0-130 57-223t184-93q65 0 115 33t63 97h70q-15-87-86-138.5T372-15Q217-15 139 92T61 361t78 269 233 107q98 0 169-46.5T612 553h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 722,
    d: "M302 60q147 0 216.5 79T588 361q0 155-85.5 228T258 662H156V60h146zm-16 662q179 0 275.5-91.5T658 361q0-177-96-269T286 0H91v722h195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 611,
    d: "M102 0v722h429v-60H167V403h350v-60H167V60h379V0H102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    d: "M95 0v722h408v-60H160V407h331v-60H160V0H95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 722,
    d: "M631 368V30Q569 6 506.5-4.5T372-15Q227-15 145.5 87.5T64 361q0 153 80 264.5T372 737q98 0 172-50.5T626 544h-74q-9 66-59.5 99.5T372 677q-120 0-179-93.5T134 361q0-147 65.5-231.5T406 45q38 0 73 7.5T566 75v233H385v60h246z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 722,
    d: "M99 0v722h65V405h394v317h65V0h-65v345H164V0H99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 278,
    d: "M107 0v725h65V0h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 500,
    d: "M83 178q5-60 42-96.5T220 45q64 0 95.5 53T347 225v497h65V235q0-55-9-97.5t-40-80-73-55T199-15q-82 0-128.5 54T13 178h70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 611,
    d: "M106 0v722h64l1-318 323 318h82L243 396 606 0h-89L171 377 170 0h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    d: "M100 0v722h65V60h363V0H100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 944,
    d: "M97 0v722h104L472 93l277 629h99V0h-65v667L505 0h-65L164 664 162 0H97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 722,
    d: "M92 722h74L564 87l2 635h65V0h-82L159 624 157 0H92v722z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 778,
    d: "M389 45q126 0 189 92t63 224-63 224-189 92-189-92-63-224 63-224 189-92zm0-60Q236-15 151.5 86.5T67 361q0 172 84.5 274T389 737t237.5-101.5T711 361q0-172-84.5-274T389-15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 611,
    d: "M165 374h158q83 0 133 32.5T506 518q0 78-50.5 111T323 662H165V374zM100 0v722h181q129 0 212-43.5T576 518q0-116-84-160t-211-44H165V0h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 778,
    d: "M389 45q126 0 189 92t63 224-63 224-189 92-189-92-63-224 63-224 189-92zm190 8l-3-2zm12-53q-8 0-36 2t-45 2q-29 0-48-6t-38-9.5-35-3.5Q236-15 151.5 86.5T67 361q0 172 84.5 274T389 737t237.5-101.5T711 361q0-94-32.5-174.5T579 55l2-2q29 5 53.5 6t64.5 1h39V0H591z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 667,
    d: "M307 404q94 0 150 23.5T513 533q0 80-48.5 104.5T342 662H168V404h139zM168 0h-65v722h236q56 0 93.5-7t75.5-30 56.5-61 18.5-91q0-57-37-98t-102-57q63-12 88-52t32-109.5 14-129T603 0h-75q-25 71-25 150-12 129-36 161.5T347 344H168V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 611,
    d: "M273-15q-88 0-151.5 57.5T58 188h70q0-77 50-110t131-33q66 0 120 37t54 102q0 50-30.5 79.5t-134 64-173.5 74T75 542q0 90 68.5 142.5T305 737q89 0 156.5-38.5T540 565h-70q0 61-45.5 86.5T313 677q-64 0-116-32.5T145 551q0-84 105-129 98-37 197-73 106-54 106-159 0-109-78.5-157T273-15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    d: "M247 662H14v60h528v-60H313L312 0h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 722,
    d: "M162 722V255q0-97 54.5-153.5T361 45t144.5 56.5T560 255v467h65V254q0-121-68-195T361-15 165 58.5 97 254v468h65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 611,
    d: "M309 65l231 657h65L344 0h-74L6 722h71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1000,
    d: "M290 0h-92L10 722h69L247 65l213 657h79L759 65l169 657h63L801 0h-89L499 655z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 611,
    d: "M82 0H8l257 372L21 722h85l204-304 212 304h73L345 372 603 0h-83L301 323z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 611,
    d: "M274 312L8 722h83l221-349 221 349h70L339 314V0h-65v312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    d: "M39 0v60l401 602H39v60h478v-60L115 60h402V0H39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 278,
    d: "M85-96v818h137v-50h-72V-46h72v-50H85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 278,
    d: "M-44 722h65L323 0h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 278,
    d: "M193 722V-96H56v50h72v718H56v50h137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 660,
    d: "M74 239l230 453h52l231-453h-57L329 631 132 239H74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 500,
    d: "M0-125v50h500v-50H0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 278,
    d: "M100 707l91-143h-44L20 707h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 500,
    d: "M214 40q89 0 119.5 58T364 253h-43q-96 0-158-21t-62-92q0-49 32-74.5T214 40zm150 314q0 58-30.5 83T245 462q-52 0-84.5-19.5T122 375H58q11 73 61 107.5T246 517q87 0 132.5-40T424 351V113q0-26 2.5-68T429 0h-62l-2 74-5-7q-17-33-62-57.5T203-15q-72 0-119.5 41.5T36 140q0 50 27 87.5t67.5 55 80 22T302 309q11 0 26.5-.5t35.5-.5v46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    d: "M130 261q0-97 40-159t131-62q78 0 111 65.5T445 258q0 84-37 144t-116 60q-82 0-122-58t-40-143zM127 0H65q0 21 2.5 62t2.5 51v609h60V428l2-2q26 43 72.5 67t99.5 24q104 0 155-77t51-187q0-108-50.5-188T307-15q-54 0-99 24t-76 69l-2-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 500,
    d: "M397 348q0 57-36 85.5T260 462q-67 0-108-60.5T111 252t41-150.5T260 40q60 0 98.5 32.5T397 157h65Q438-15 266-15q-106 0-163 77T46 251q0 110 59 188t165 78q81 0 136.5-45.5T462 348h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    d: "M262 462q-78 0-114.5-59.5T111 260q0-89 31.5-154.5T253 40q91 0 131 63t40 160q0 85-40 142t-122 57zM426 74l-2 4q-64-93-172-93-104 0-155 79.5T46 253q0 110 51 187t155 77q52 0 99-23.5t73-67.5l2 2v294h60V113q0-26 2.5-68T491 0h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    d: "M115 237q0-88 42.5-142.5T289 40q52 0 93 34t52 86h63q-23-89-79-132T270-15q-106 0-163 77T50 251q0 110 59 188t165 78q119 0 174-76.5T503 237H115zm323 55q0 75-43 122.5T275 462q-70 0-110.5-49T117 292h321z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 333,
    d: "M123 0v447H22v55h101v107q0 66 28.5 95.5T244 734q11 0 27-4t30-7v-48q-9 1-17 2.5t-20 1.5q-56 0-68.5-24T183 566v-64h114v-55H183V0h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    d: "M265 462q-75 0-115-61.5T110 260t40-141 117-62q80 0 119.5 61T426 262q0 79-42.5 139.5T265 462zm164 40h62q0-21-2.5-62t-2.5-51V88q0-106-16-164t-66.5-82-77.5-29-60-5q-82 0-140.5 31.5T67-57h65q5-41 46-60.5t96-19.5q60 0 106 39T426 2v94q-23-43-68.5-68.5T261 2Q154 2 99.5 73T45 255q0 113 53 187.5T259 517q54 0 93.5-23t71.5-70l2 4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    d: "M140 426q27 46 68 68.5t91 22.5q107 0 142-64t35-139V0h-60v324q0 65-34.5 101.5T284 462q-71 0-107.5-49.5T140 289V0H80v722h60V426z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 222,
    d: "M141 502V0H81v502h60zm5 145H76v75h70v-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 222,
    d: "M3-137q54 0 66 16.5T81-37v539h60V-22q0-106-21.5-138T3-192v55zm143 784H76v75h70v-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 500,
    d: "M146 297l243 205h77L212 285 486 0h-76L146 272V0H86v722h60V297z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 222,
    d: "M141 0H81v722h60V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 889,
    d: "M139 428l2-2q26 46 66 68.5t91 22.5q59 0 102.5-29.5T461 407q31 49 74.5 79.5T634 517q107 0 142-64t35-139V0h-60v324q0 65-34.5 101.5T619 462q-71 0-107.5-49.5T475 289V0h-60v324q0 65-34.5 101.5T283 462q-71 0-107.5-49.5T139 289V0H79v389q0 26-2.5 68T74 502h62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    d: "M140 0H80v389q0 26-2.5 68T75 502h62l3-74 2-2q26 46 66 68.5t91 22.5q107 0 142-64t35-139V0h-60v324q0 65-34.5 101.5T284 462q-71 0-107.5-49.5T140 289V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    d: "M278 462q-84 0-126.5-64.5T109 251q0-81 43-146t126-65q84 0 126.5 64.5T447 251q0 81-43 146t-126 65zm234-211q0-108-61-187T278-15q-113 0-173.5 78.5T44 251q0 108 61 187t173 79q113 0 173.5-78.5T512 251z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    d: "M301 40q77 0 110.5 66.5T445 260q0 84-37 143t-116 59q-82 0-122-57t-40-142q0-97 40-160t131-63zM130-192H70v581q0 26-2.5 68T65 502h62l3-74 2-2q26 43 72.5 67t99.5 24q104 0 155-77t51-187q0-108-50.5-188T307-15q-54 0-99 24t-76 69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    d: "M264 462q-78 0-115.5-60T111 260q0-88 32.5-154T255 40q91 0 131 63t40 160q0 85-40 142t-122 57zm165 40h62q0-21-2.5-62t-2.5-51v-580h-60V78q-32-45-77-69T249-15Q148-15 97 65T46 253q0 110 51 187t155 77q52 0 99-23.5t73-65.5l2-3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 333,
    d: "M140 0H80v389q0 26-2.5 68T75 502h62l3-74q16 40 46.5 64.5T255 517q15 0 30-.5t30-.5v-58q-6 0-18 2t-19 2q-65 0-101.5-43.5T140 302V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 500,
    d: "M247 517q81 0 132-32t51-107h-65q-4 43-38.5 63.5T241 462q-47 0-80-20t-33-61q0-46 74.5-68.5t136-41 84.5-50 23-72.5q0-80-62-122T235-15q-75 0-132 37.5T46 137h65q0-51 40.5-74T250 40q54 0 92.5 25t38.5 75q0 57-44 71.5t-118.5 32-115 44T63 377q0 72 54 106t130 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 333,
    d: "M123 447H23v55h100v107l60 26V502h114v-55H183V111q0-71 69-71 16 0 28 1t24 5V-6q-22-6-33-7.5T243-15q-83 0-101.5 37.5T123 134v313z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    d: "M416 502h60V113q0-26 2.5-68T481 0h-62l-3 74-2 2q-26-46-66-68.5T257-15q-107 0-142 64T80 188v314h60V178q0-65 34.5-101.5T272 40q71 0 107.5 49.5T416 213v289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 500,
    d: "M80 502L253 83l167 419h66L287 0h-68L14 502h66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 833,
    d: "M232 79l154 423h71L605 83l147 419h66L631 0h-57L420 433 261 0h-61L16 502h66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 500,
    d: "M404 502h63L287 259 483 0h-79L243 218 85 0H17l2 2 192 255L26 502h80l147-202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 500,
    d: "M81 502L250 82l168 420h65L206-192h-66L216 0 8 502h73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 444,
    d: "M40 55l293 392H40v55h364v-55L113 55h291V0H40v55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 278,
    d: "M248-96h-50q-34 3-61 33t-27 76v143q0 63-14 93t-58 35v55q43 5 57.5 36.5T110 469v144q0 46 27 76t61 33h50v-50h-33q-20-5-30-22.5T175 597V454q0-60-19.5-90T110 312q30-22 47.5-57.5T175 171V29q0-66 40-75h33v-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 222,
    d: "M81 750h60V-250H81V750z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 278,
    d: "M30 722h50q34-3 61-33t27-76V470q0-64 14-94t58-35v-55q-43-5-57.5-36T168 157V13q0-46-27-76T80-96H30v50h33q20 5 30 22.5T103 29v143q0 60 19.5 90t45.5 52q-30 22-47.5 57.5T103 455v142q0 66-40 75H30v50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 660,
    d: "M338 283q46-21 65.5-28.5T441 247q30 0 55 26t44 61l40-34q-25-48-59-78.5T440 191q-25 0-51 9t-84 33q-27 13-47.5 22t-36.5 9q-42 0-65.5-32T113 169l-33 47q31 47 62.5 75t78.5 28q21 0 44.5-6.5T338 283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\\xC4",
    horizAdvX: 667,
    d: "M488 255L332 662 173 255h315zM9 0l286 722h76L659 0h-71l-77 195H152L76 0H9zm375 839v88h74v-88h-74zm-174 0v88h74v-88h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\\xC5",
    horizAdvX: 667,
    d: "M488 255L332 662 173 255h315zM9 0l286 722h76L659 0h-71l-77 195H152L76 0H9zm325 957q36 0 62-26t26-62-26-62-62-26-62 26-26 62 26 62 62 26zm0-33q-22 0-38.5-16.5T279 869q0-20 16.5-37.5T334 814q21 0 38 17t17 38-17 38-38 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\\xC7",
    horizAdvX: 667,
    d: "M542 553q-9 63-55.5 93.5T372 677q-127 0-184-92.5T131 361q0-130 57-223t184-93q65 0 115 33t63 97h70q-15-87-86-138.5T372-15h-13q-7 0-21 2l-10-37q46 0 73.5-13t27.5-54q0-32-29-49t-64-17q-42 0-69 8.5T223-161l7 28q27-10 44.5-15.5T319-158q9-1 22.5 2.5T364-144t9 29q0 19-14 27.5T325-79l-33-3 23 72Q188 10 124.5 112.5T61 361q0 162 78 269t233 107q98 0 169-46.5T612 553h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\\xC9",
    horizAdvX: 611,
    d: "M102 0v722h429v-60H167V403h350v-60H167V60h379V0H102zm323 927L298 784h-44l91 143h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\\xD1",
    horizAdvX: 722,
    d: "M92 722h74L564 87l2 635h65V0h-82L159 624 157 0H92v722zm388 193h19q-9-37-32-61t-59-24q-10 0-20 2.5t-25 8-26.5 8T309 851t-29.5-7.5T262 822h-38q8 37 31.5 59t58.5 22q12 0 18.5-1t11-2 22-6.5T394 885t17-3q37 0 50 33h19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\\xD6",
    horizAdvX: 778,
    d: "M389 45q126 0 189 92t63 224-63 224-189 92-189-92-63-224 63-224 189-92zm0-60Q236-15 151.5 86.5T67 361q0 172 84.5 274T389 737t237.5-101.5T711 361q0-172-84.5-274T389-15zm50 854v88h74v-88h-74zm-174 0v88h74v-88h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\\xDC",
    horizAdvX: 722,
    d: "M162 722V255q0-97 54.5-153.5T361 45t144.5 56.5T560 255v467h65V254q0-121-68-195T361-15 165 58.5 97 254v468h65zm249 117v88h74v-88h-74zm-174 0v88h74v-88h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\\xE1",
    horizAdvX: 500,
    d: "M214 40q89 0 119.5 58T364 253h-43q-96 0-158-21t-62-92q0-49 32-74.5T214 40zm150 314q0 58-30.5 83T245 462q-52 0-84.5-19.5T122 375H58q11 73 61 107.5T246 517q87 0 132.5-40T424 351V113q0-26 2.5-68T429 0h-62l-2 74-5-7q-17-33-62-57.5T203-15q-72 0-119.5 41.5T36 140q0 50 27 87.5t67.5 55 80 22T302 309q11 0 26.5-.5t35.5-.5v46zm5 353L242 564h-44l91 143h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\\xE0",
    horizAdvX: 500,
    d: "M214 40q89 0 119.5 58T364 253h-43q-96 0-158-21t-62-92q0-49 32-74.5T214 40zm150 314q0 58-30.5 83T245 462q-52 0-84.5-19.5T122 375H58q11 73 61 107.5T246 517q87 0 132.5-40T424 351V113q0-26 2.5-68T429 0h-62l-2 74-5-7q-17-33-62-57.5T203-15q-72 0-119.5 41.5T36 140q0 50 27 87.5t67.5 55 80 22T302 309q11 0 26.5-.5t35.5-.5v46zM211 707l91-143h-44L131 707h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\\xE2",
    horizAdvX: 500,
    d: "M214 40q89 0 119.5 58T364 253h-43q-96 0-158-21t-62-92q0-49 32-74.5T214 40zm150 314q0 58-30.5 83T245 462q-52 0-84.5-19.5T122 375H58q11 73 61 107.5T246 517q87 0 132.5-40T424 351V113q0-26 2.5-68T429 0h-62l-2 74-5-7q-17-33-62-57.5T203-15q-72 0-119.5 41.5T36 140q0 50 27 87.5t67.5 55 80 22T302 309q11 0 26.5-.5t35.5-.5v46zM214 707h73l99-145h-47l-89 106-90-106h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\\xE4",
    horizAdvX: 500,
    d: "M214 40q89 0 119.5 58T364 253h-43q-96 0-158-21t-62-92q0-49 32-74.5T214 40zm150 314q0 58-30.5 83T245 462q-52 0-84.5-19.5T122 375H58q11 73 61 107.5T246 517q87 0 132.5-40T424 351V113q0-26 2.5-68T429 0h-62l-2 74-5-7q-17-33-62-57.5T203-15q-72 0-119.5 41.5T36 140q0 50 27 87.5t67.5 55 80 22T302 309q11 0 26.5-.5t35.5-.5v46zm-64 265v88h74v-88h-74zm-174 0v88h74v-88h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\\xE3",
    horizAdvX: 500,
    d: "M214 40q89 0 119.5 58T364 253h-43q-96 0-158-21t-62-92q0-49 32-74.5T214 40zm150 314q0 58-30.5 83T245 462q-52 0-84.5-19.5T122 375H58q11 73 61 107.5T246 517q87 0 132.5-40T424 351V113q0-26 2.5-68T429 0h-62l-2 74-5-7q-17-33-62-57.5T203-15q-72 0-119.5 41.5T36 140q0 50 27 87.5t67.5 55 80 22T302 309q11 0 26.5-.5t35.5-.5v46zm5 341h19q-9-37-32-61t-59-24q-10 0-20 2.5t-25 8-26.5 8T198 631t-29.5-7.5T151 602h-38q8 37 31.5 59t58.5 22q12 0 18.5-1t11-2 22-6.5T283 665t17-3q37 0 50 33h19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\\xE5",
    horizAdvX: 500,
    d: "M214 40q89 0 119.5 58T364 253h-43q-96 0-158-21t-62-92q0-49 32-74.5T214 40zm150 314q0 58-30.5 83T245 462q-52 0-84.5-19.5T122 375H58q11 73 61 107.5T246 517q87 0 132.5-40T424 351V113q0-26 2.5-68T429 0h-62l-2 74-5-7q-17-33-62-57.5T203-15q-72 0-119.5 41.5T36 140q0 50 27 87.5t67.5 55 80 22T302 309q11 0 26.5-.5t35.5-.5v46zM250 737q36 0 62-26t26-62-26-62-62-26-62 26-26 62 26 62 62 26zm0-33q-22 0-38.5-16.5T195 649q0-20 16.5-37.5T250 594q21 0 38 17t17 38-17 38-38 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\\xE7",
    horizAdvX: 500,
    d: "M397 348q0 57-36 85.5T260 462q-67 0-108-60.5T111 252t41-150.5T260 40q60 0 98.5 32.5T397 157h65Q438-15 266-15l-12 1-10-36q46 0 73.5-13t27.5-54q0-32-29-49t-64-17q-42 0-69 8.5T139-161l7 28q27-10 44.5-15.5T235-158q9-1 22.5 2.5T280-144t9 29q0 19-14 27.5T241-79l-33-3 23 70Q140 2 93 76T46 251q0 110 59 188t165 78q81 0 136.5-45.5T462 348h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\\xE9",
    d: "M115 237q0-88 42.5-142.5T289 40q52 0 93 34t52 86h63q-23-89-79-132T270-15q-106 0-163 77T50 251q0 110 59 188t165 78q119 0 174-76.5T503 237H115zm323 55q0 75-43 122.5T275 462q-70 0-110.5-49T117 292h321zm-41 415L270 564h-44l91 143h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\\xE8",
    d: "M115 237q0-88 42.5-142.5T289 40q52 0 93 34t52 86h63q-23-89-79-132T270-15q-106 0-163 77T50 251q0 110 59 188t165 78q119 0 174-76.5T503 237H115zm323 55q0 75-43 122.5T275 462q-70 0-110.5-49T117 292h321zM239 707l91-143h-44L159 707h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\\xEA",
    d: "M115 237q0-88 42.5-142.5T289 40q52 0 93 34t52 86h63q-23-89-79-132T270-15q-106 0-163 77T50 251q0 110 59 188t165 78q119 0 174-76.5T503 237H115zm323 55q0 75-43 122.5T275 462q-70 0-110.5-49T117 292h321zM242 707h73l99-145h-47l-89 106-90-106h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\\xEB",
    d: "M115 237q0-88 42.5-142.5T289 40q52 0 93 34t52 86h63q-23-89-79-132T270-15q-106 0-163 77T50 251q0 110 59 188t165 78q119 0 174-76.5T503 237H115zm323 55q0 75-43 122.5T275 462q-70 0-110.5-49T117 292h321zM328 619v88h74v-88h-74zm-174 0v88h74v-88h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\\xED",
    horizAdvX: 222,
    d: "M81 0v502h60V0H81zm149 707L103 564H59l91 143h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\\xEC",
    horizAdvX: 222,
    d: "M81 0v502h60V0H81zm-9 707l91-143h-44L-8 707h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\\xEE",
    horizAdvX: 222,
    d: "M81 0v502h60V0H81zm-6 707h73l99-145h-47l-89 106-90-106h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\\xEF",
    horizAdvX: 222,
    d: "M81 0v502h60V0H81zm80 619v88h74v-88h-74zm-174 0v88h74v-88h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\\xF1",
    d: "M140 0H80v389q0 26-2.5 68T75 502h62l3-74 2-2q26 46 66 68.5t91 22.5q107 0 142-64t35-139V0h-60v324q0 65-34.5 101.5T284 462q-71 0-107.5-49.5T140 289V0zm257 695h19q-9-37-32-61t-59-24q-10 0-20 2.5t-25 8-26.5 8T226 631t-29.5-7.5T179 602h-38q8 37 31.5 59t58.5 22q12 0 18.5-1t11-2 22-6.5T311 665t17-3q37 0 50 33h19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\\xF3",
    d: "M278 462q-84 0-126.5-64.5T109 251q0-81 43-146t126-65q84 0 126.5 64.5T447 251q0 81-43 146t-126 65zm234-211q0-108-61-187T278-15q-113 0-173.5 78.5T44 251q0 108 61 187t173 79q113 0 173.5-78.5T512 251zM397 707L270 564h-44l91 143h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\\xF2",
    d: "M278 462q-84 0-126.5-64.5T109 251q0-81 43-146t126-65q84 0 126.5 64.5T447 251q0 81-43 146t-126 65zm234-211q0-108-61-187T278-15q-113 0-173.5 78.5T44 251q0 108 61 187t173 79q113 0 173.5-78.5T512 251zM239 707l91-143h-44L159 707h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\\xF4",
    d: "M278 462q-84 0-126.5-64.5T109 251q0-81 43-146t126-65q84 0 126.5 64.5T447 251q0 81-43 146t-126 65zm234-211q0-108-61-187T278-15q-113 0-173.5 78.5T44 251q0 108 61 187t173 79q113 0 173.5-78.5T512 251zM242 707h73l99-145h-47l-89 106-90-106h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\\xF6",
    d: "M278 462q-84 0-126.5-64.5T109 251q0-81 43-146t126-65q84 0 126.5 64.5T447 251q0 81-43 146t-126 65zm234-211q0-108-61-187T278-15q-113 0-173.5 78.5T44 251q0 108 61 187t173 79q113 0 173.5-78.5T512 251zM328 619v88h74v-88h-74zm-174 0v88h74v-88h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\\xF5",
    d: "M278 462q-84 0-126.5-64.5T109 251q0-81 43-146t126-65q84 0 126.5 64.5T447 251q0 81-43 146t-126 65zm234-211q0-108-61-187T278-15q-113 0-173.5 78.5T44 251q0 108 61 187t173 79q113 0 173.5-78.5T512 251zM397 695h19q-9-37-32-61t-59-24q-10 0-20 2.5t-25 8-26.5 8T226 631t-29.5-7.5T179 602h-38q8 37 31.5 59t58.5 22q12 0 18.5-1t11-2 22-6.5T311 665t17-3q37 0 50 33h19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\\xFA",
    d: "M416 502h60V113q0-26 2.5-68T481 0h-62l-3 74-2 2q-26-46-66-68.5T257-15q-107 0-142 64T80 188v314h60V178q0-65 34.5-101.5T272 40q71 0 107.5 49.5T416 213v289zm-19 205L270 564h-44l91 143h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\\xF9",
    d: "M416 502h60V113q0-26 2.5-68T481 0h-62l-3 74-2 2q-26-46-66-68.5T257-15q-107 0-142 64T80 188v314h60V178q0-65 34.5-101.5T272 40q71 0 107.5 49.5T416 213v289zM239 707l91-143h-44L159 707h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\\xFB",
    d: "M416 502h60V113q0-26 2.5-68T481 0h-62l-3 74-2 2q-26-46-66-68.5T257-15q-107 0-142 64T80 188v314h60V178q0-65 34.5-101.5T272 40q71 0 107.5 49.5T416 213v289zM242 707h73l99-145h-47l-89 106-90-106h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\\xFC",
    d: "M416 502h60V113q0-26 2.5-68T481 0h-62l-3 74-2 2q-26-46-66-68.5T257-15q-107 0-142 64T80 188v314h60V178q0-65 34.5-101.5T272 40q71 0 107.5 49.5T416 213v289zm-88 117v88h74v-88h-74zm-174 0v88h74v-88h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\\u2020",
    d: "M76 487v55h172v180h60V542h172v-55H308V0h-60v487H76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\\xB0",
    horizAdvX: 400,
    d: "M200 407q-62 0-106 44T50 557t44 106 106 44 106-44 44-106-44-106-106-44zm0 45q46 0 75.5 29.5T305 557q0 45-30 75t-76 30q-44 0-74-30t-30-75q0-46 29.5-75.5T200 452z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\\xA2",
    d: "M313 460l-29 2q-67 0-108-60.5T135 252q0-57 18-105.5T204 71zm50 179h44l-38-134q52-18 84.5-59t32.5-98h-65q0 38-18 64t-49 38L242 48q21-8 42-8 60 0 98.5 32.5T421 157h65Q462-15 290-15q-36 0-63 9l-36-127h-45l41 144q-58 32-87.5 96.5T70 251q0 110 59 188t165 78l34-3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\\xA3",
    d: "M60 0v60h60v312H46v60h75q0 131 43.5 203T340 707q79 0 133-38.5T527 564h-70q0 38-35.5 60.5T332 647q-74 0-110.5-48T185 474v-42h162v-60H185V60h320V0H60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\\xA7",
    d: "M176 365q0-37 53-63 35-15 48-20 31 17 62 35 34 25 34 59 0 32-43 54-35 15-70 31-51-32-67.5-46.5T176 365zm229 298q-16 7-48.5 13t-50.5 6q-47 0-82-17.5T189 604t64-74l120-52q65-36 65-90 0-40-30-70.5T333 266q53-20 82-48.5t29-78.5q0-76-57-115T252-15q-34 0-66 5T123 7v57q58-24 124-24 54 0 93 23.5t39 74.5q0 48-134 93T111 359q0 41 31 71t76 50q-46 25-70 51.5T124 601q0 71 51 103.5T300 737q21 0 37.5-3t67.5-16v-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\\u2022",
    horizAdvX: 500,
    d: "M249 181q-73 0-126 53T70 361q0 75 52.5 127.5T249 541q75 0 128-52t53-128q0-74-53-127t-128-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\\xB6",
    horizAdvX: 650,
    d: "M258 336q-77 0-134.5 56.5T66 526q0 93 58.5 144.5T289 722h217v-868h-65v808H323v-808h-65v482z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\\xDF",
    horizAdvX: 611,
    d: "M147 0H87v509q0 106 51 167t154 61q75 0 127.5-41T472 582q0-43-59-101t-59-79q0-39 54-72t106-64q56-45 56-112 0-78-48.5-123.5T398-15q-73 0-117.5 41.5T236 141h65q0-45 26-73t69-28q51 0 80 28t29 83q0 43-108 114T289 395q0 45 59 101t59 88q0 47-36.5 72.5T285 682q-74 0-106-57t-32-137V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\\xAE",
    horizAdvX: 800,
    d: "M24 362q0 155 110 265t267 110q155 0 265-110t110-265T666 96 401-15Q245-15 134.5 95.5T24 362zm692 0q0 137-89 226t-226 89-227-89-90-226q0-139 89-228t228-89q137 0 226 89t89 228zM315 149h-55v430h185q82 0 116-29t34-90q0-60-36.5-90T462 340l128-191h-62L407 340h-92V149zm76 241h33q53 0 82 13t29 58q0 40-27.5 54T433 529H315V390h76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\\xA9",
    horizAdvX: 800,
    d: "M24 362q0 155 110 265t267 110q155 0 265-110t110-265T666 96 401-15Q245-15 134.5 95.5T24 362zM401 45q137 0 226 89t89 228q0 137-89 226t-226 89-227-89-90-226q0-139 89-228t228-89zm190 249q-6-66-56-106t-117-40q-93 0-150.5 61.5T210 365q0 95 55 155t150 60q69 0 117.5-37.5T591 438h-55q-8 40-41.5 66T416 530q-71 0-108.5-47T270 366q0-68 39.5-118T418 198q44 0 78 27t40 69h55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\\u2122",
    horizAdvX: 940,
    d: "M349 682H217V301h-55v381H29v40h320v-40zm294-271l120 311h99V301h-55v377L660 301h-34L481 678l-2-377h-55v421h99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\\xB4",
    horizAdvX: 278,
    d: "M258 707L131 564H87l91 143h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\\xA8",
    horizAdvX: 278,
    d: "M189 619v88h74v-88h-74zm-174 0v88h74v-88H15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\\u2260",
    horizAdvX: 549,
    d: "M413 336h91v-64H355l-73-72h222v-64H223L105 18 62 62l74 74H45v64h150l73 72H45v64h281l118 118 44-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\\xC6",
    horizAdvX: 1000,
    d: "M925 722v-60H536l43-259h328v-60H588l47-283h299V0H578l-34 196H194L80 0H8l418 722h499zM228 256h308l-69 406z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\\xD8",
    horizAdvX: 778,
    d: "M571 593q-31 39-77.5 61.5T389 677q-126 0-189-92t-63-224q0-60 11.5-109.5T186 160zM83-15L54 12l84 94q-35 46-53 111T67 361q0 172 84.5 274T389 737q72 0 129-23.5t99-68.5l82 92 27-25-85-97q70-97 70-254 0-172-84.5-274T389-15q-71 0-127.5 23T163 76zm126 142q32-40 76-61t104-21q126 0 189 92t63 224q0 58-11.5 107T593 561z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\\u221E",
    horizAdvX: 713,
    d: "M383 271q23-45 58-70 35-23 77-23 52 0 84.5 35t32.5 90q0 56-30 89.5T525 426q-37 0-71-36t-71-119zm-53 56q-26 46-59 69.5T195 420q-51 0-84-35t-33-90q0-54 29.5-88.5T184 172q40 0 71.5 31.5T330 327zm36-89q-33-62-71.5-93T209 114q-66 0-111 52.5T53 298q0 83 41 134.5T199 484q47 0 82.5-29.5T347 360q31 62 69.5 93t87.5 31q63 0 109-53t46-131q0-83-40.5-134.5T514 114q-46 0-84 30-36 31-64 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\\xB1",
    horizAdvX: 660,
    d: "M300 502h60V330h220v-60H360V100h-60v170H80v60h220v172zM80 60h500V0H80v60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\\u2264",
    horizAdvX: 549,
    d: "M506 18H43v68h463V18zM162 280l344-107v-70L44 248v65l462 145v-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\\u2265",
    horizAdvX: 549,
    d: "M506 18H43v68h463V18zm0 230L43 103v70l344 107L43 388v70l463-145v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\\xA5",
    d: "M247 0v136H44v60h203v60H44v60h201L1 692h83l201-319 200 319h70L313 316h199v-60H312v-60h200v-60H312V0h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\\xB5",
    d: "M416 502h60V113q0-26 2.5-68T481 0h-62l-3 74-2 2q-26-46-66-68.5T257-15q-26 0-56.5 6.5T140 10v-202H80v694h60V178q0-65 34.5-101.5T272 40q71 0 107.5 49.5T416 213v289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\\u2202",
    horizAdvX: 494,
    d: "M256 349q-52 0-86-60t-34-161q0-57 21.5-88T220 9q53 0 87 62t34 153q0 58-21.5 91.5T256 349zm102-62q4 14 6.5 28t2.5 31l3 89q0 85-15.5 126T307 602q-18 0-50-35t-56-35q-16 0-25.5 7.5T164 564q0 29 30.5 50t71.5 21q77 0 111.5-54T424 478t12-111q0-163-64.5-271.5T214-13q-68 0-110 51T62 175q0 82 53 143.5T240 380q44 0 72.5-22t45.5-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\\u03A3",
    horizAdvX: 713,
    d: "M618 643l15-129h-44q-32 105-85 144t-169 39H203l315-431-344-394h187q122 0 172.5 31.5T616 20h45l-30-130-2-7q-23-99-111-99H36l389 446L50 744h460q65 0 82-15 17-13 26-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\\u220F",
    horizAdvX: 823,
    d: "M118-176v880H30v40h767v-40h-88v-880h88v-40H533v40h84v880H210v-880h84v-40H30v40h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\\u03C0",
    horizAdvX: 549,
    d: "M404 373l-1-24-3-150v-40q0-84 8.5-105T439 33q28 0 41 29 17 31 17 89h25v-5q0-80-26-118t-80-38q-56 0-79.5 40T313 194l1 78 3 104-50 1-77 2q0-234-23-311.5T87-10q-35 0-52.5 29T17 105v19h24q0-27 9.5-39.5T78 72q42 0 54.5 47t18 110.5T156 379h-22q-38 0-59.5-13.5T47 326H24q0 34 10 57.5T70.5 428 183 449l102-3 152-3q34 0 49.5 7t16.5 21l23 1q0-53-23.5-76.5T428 372h-14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\\u222B",
    horizAdvX: 274,
    d: "M283 757q36 0 58.5-18.5T364 690q0-20-13-34t-36-14q-29 0-44 32t-29 32q-57 0-57-310l-3-98q0-63-4.5-120t-14-128-31-120-60-80T-9-181q-35 0-58 18.5T-90-114q0 22 12.5 34.5T-41-67q29 0 44-31t30-32q57 0 57 324l2 84q0 60 4 116t13.5 127.5T141 644t59.5 82 82.5 31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\\xAA",
    horizAdvX: 300,
    d: "M232 572h-32q-55 0-91-11.5T73 511q0-29 16.5-41t49.5-12q54 0 74.5 32t20.5 84zm0 67q0 35-17 46.5T159 697q-33 0-52-8.5T84 652H38q6 44 39 64.5t83 20.5q56 0 86-24t30-75V473q0-7 2-26t2-20h-46l-3 40q-13-20-40-34.5T132 418q-47 0-78 25t-31 68q0 30 18 52.5t44.5 33 51.5 13 61 2.5h34v27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\\xBA",
    horizAdvX: 334,
    d: "M167 458q48 0 75 36.5t27 83.5-26 83-76 36q-49 0-75.5-36.5T65 578q0-48 26-84t76-36zm152 120q0-66-39.5-113T167 418 54.5 465 15 578q0 65 39.5 112T167 737t112.5-47T319 578z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\\u03A9",
    horizAdvX: 768,
    d: "M593 90q48 0 68 19t20 67h23V0H432v180q77 15 122.5 76.5T600 408q0 106-59 168.5T384 639t-157-62.5T168 408q0-90 44.5-151T336 180V0H64v176h23q0-48 19-67t69-19h123v59q-118 21-183 89T50 408q0 121 92.5 194T384 675t241.5-73.5T718 408q0-100-64-168t-184-91V90h123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\\xE6",
    horizAdvX: 833,
    d: "M713 299q0 71-35.5 117T567 462q-63 0-101-50.5T428 299h285zM58 375q11 73 61 107.5T246 517q54 0 100-28t57-77q24 51 67 78t89 27q112 0 165.5-75.5T778 244H428q0-88 31.5-146T564 40q52 0 93 34t52 86h63q-23-87-76-131T565-15q-55 0-100 31.5T398 104q-22-58-73.5-88.5T203-15q-72 0-119.5 41.5T36 140q0 48 27.5 82.5T129 274t75 21.5 86 4.5q18 0 36.5-.5t36.5-.5v55q0 59-30 83.5T245 462q-52 0-84.5-19.5T122 375H58zm228-131q-90 0-137.5-20.5T101 126q0-41 35.5-63.5T216 40q86 0 116.5 55T363 243z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\\xF8",
    d: "M395 407q-21 26-50 40.5T278 462q-84 0-126.5-64.5T109 251q0-32 7.5-63.5T140 127zM159 97q21-26 50.5-41.5T278 40q84 0 126.5 64.5T447 251q0 35-7.5 65.5T415 377zM95 78q-25 35-38 81t-13 92q0 108 61 187t173 79q51 0 90.5-16.5T437 453l59 64 24-25-60-66q25-36 38.5-81.5T512 251q0-108-61-187T278-15q-50 0-91 17t-70 48L57-15 33 10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\\xBF",
    horizAdvX: 500,
    d: "M325 376V268q0-38-46.5-83.5T188 96q-49-55-49-107 0-65 45.5-93T301-132q24 0 46.5 4t47.5 11v-61q-25-8-52-11t-58-3q-92 0-151.5 45.5T74-13q0 67 30 104t68.5 75 72.5 73q20 24 20 53v84h60zm10 166v-86h-80v86h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\\xA1",
    horizAdvX: 389,
    d: "M235 542v-86h-80v86h80zm-12-171l13-551h-82l13 551h56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\\xAC",
    horizAdvX: 660,
    d: "M520 318H80v60h500V112h-60v206z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\\u221A",
    horizAdvX: 549,
    d: "M594 764h-57L247-20h-32L59 411l-61-22-12 39 138 48 125-346 252 681h93v-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\\u0192",
    d: "M139 408l9 60h94l16 80q12 72 39 115.5t95 43.5q14 0 29-1.5t42-5.5l-8-57q-19 4-44 4-41 0-58.5-19.5T328 568l-20-100h106l-8-60H299L229 45q-26-133-47-185T78-192q-23 0-46 6l11 54q15-4 28-4 11 0 28 5.5T126.5-99 149-24l84 432h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\\u2248",
    horizAdvX: 549,
    d: "M15 100v77q49 31 87 44.5t74 13.5q44 0 115-24t99-24 61.5 15 82.5 52v-78q-42-28-76.5-41.5T385 121q-32 0-104 23.5T165 168q-28 0-53.5-11t-48-24.5T15 100zm0 119v77q23 14 43.5 25t50.5 21.5 66 10.5q42 0 114.5-23.5T390 306q27 0 60 14.5t84 51.5v-77q-18-12-41-24t-49-21.5-59-9.5-104.5 23.5T170 287q-35 0-66-13.5T15 219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\\u2206",
    horizAdvX: 612,
    d: "M92 45h373L279 504zM595 0H21l276 672h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\\xAB",
    d: "M439 462l-93-195 92-195h-50L282 267l106 195h51zm-180 0l-93-195 92-195h-50L102 267l106 195h51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\\xBB",
    d: "M117 72l93 195-92 195h50l106-195L168 72h-51zm180 0l93 195-92 195h50l106-195L348 72h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\\u2026",
    horizAdvX: 1000,
    d: "M207 86V0h-80v86h80zm333 0V0h-80v86h80zm333 0V0h-80v86h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonbreakingspace",
    horizAdvX: 250
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\\xC0",
    horizAdvX: 667,
    d: "M488 255L332 662 173 255h315zM9 0l286 722h76L659 0h-71l-77 195H152L76 0H9zm286 927l91-143h-44L215 927h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\\xC3",
    horizAdvX: 667,
    d: "M488 255L332 662 173 255h315zM9 0l286 722h76L659 0h-71l-77 195H152L76 0H9zm444 915h19q-9-37-32-61t-59-24q-10 0-20 2.5t-25 8-26.5 8T282 851t-29.5-7.5T235 822h-38q8 37 31.5 59t58.5 22q12 0 18.5-1t11-2 22-6.5T367 885t17-3q37 0 50 33h19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\\xD5",
    horizAdvX: 778,
    d: "M389 45q126 0 189 92t63 224-63 224-189 92-189-92-63-224 63-224 189-92zm0-60Q236-15 151.5 86.5T67 361q0 172 84.5 274T389 737t237.5-101.5T711 361q0-172-84.5-274T389-15zm119 930h19q-9-37-32-61t-59-24q-10 0-20 2.5t-25 8-26.5 8T337 851t-29.5-7.5T290 822h-38q8 37 31.5 59t58.5 22q12 0 18.5-1t11-2 22-6.5T422 885t17-3q37 0 50 33h19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\\u0152",
    horizAdvX: 1000,
    d: "M363 45q89 0 139.5 46.5T553 221v253q0 106-48 154.5T363 677q-113 0-172.5-92.5T131 361q0-130 59.5-223T363 45zm192 24h-4q-31-41-82-62.5T363-15Q224-15 142.5 87.5T61 361q0 170 81.5 273T363 737q56 0 102.5-17.5T555 659v63h376v-60H620V403h297v-60H620V60h326V0H555v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\\u0153",
    horizAdvX: 889,
    d: "M269 462q-78 0-119-65t-41-146q0-80 41.5-145.5T269 40q84 0 120 63t36 153q0 83-37 144.5T269 462zm506-170q0 77-35 123.5T629 462q-64 0-101.5-52T490 292h285zm-285-55q0-84 31.5-140.5T626 40q52 0 93 34t52 86h63q-23-87-76-131T627-15q-60 0-107 31.5T457 110q-23-61-71-93T278-15q-113 0-173.5 78.5T44 251q0 108 61 187t173 79q60 0 107-33t71-92q19 60 65.5 92.5T621 517q113 0 166-76.5T840 237H490z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\\u2013",
    horizAdvX: 500,
    d: "M0 237v60h500v-60H0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\\u2014",
    horizAdvX: 1000,
    d: "M0 237v60h1000v-60H0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\\u201C",
    d: "M303 517l72 205h52l-43-205h-81zm-184 0l72 205h52l-43-205h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\\u201D",
    d: "M437 722l-72-205h-52l43 205h81zm-184 0l-72-205h-52l43 205h81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\\u2018",
    horizAdvX: 278,
    d: "M73 517l72 205h52l-43-205H73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\\u2019",
    horizAdvX: 278,
    d: "M205 722l-72-205H81l43 205h81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\\xF7",
    horizAdvX: 660,
    d: "M80 281h500v-60H80v60zM293 0v88h75V0h-75zm0 414v88h75v-88h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\\u25CA",
    horizAdvX: 494,
    d: "M247 688L59 289l188-403 188 403zm0 119l244-518-244-522L3 289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\\xFF",
    horizAdvX: 500,
    d: "M81 502L250 82l168 420h65L206-192h-66L216 0 8 502h73zm219 117v88h74v-88h-74zm-174 0v88h74v-88h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\\u0178",
    horizAdvX: 611,
    d: "M274 312L8 722h83l221-349 221 349h70L339 314V0h-65v312zm82 527v88h74v-88h-74zm-174 0v88h74v-88h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\\u2215",
    horizAdvX: 167,
    d: "M-96 0h-55l417 707h53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\\xA4",
    d: "M75 152q-48 71-48 148 0 44 11 79.5T75 451l-43 43 52 53 44-43q65 49 154 49 40 0 75.5-12.5T428 504l44 43 52-53-43-43q48-69 48-156 0-72-48-143l43-42-52-53-44 43q-68-50-155-50-40 0-75 12.5T128 100L84 57l-52 53zm384 151q0 72-52 126t-125 54q-78 0-131.5-52.5T97 300q0-72 53-126t126-54q75 0 129 53t54 130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\\u2039",
    horizAdvX: 278,
    d: "M215 462l-93-195 92-195h-50L58 267l106 195h51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\\u203A",
    horizAdvX: 278,
    d: "M63 72l93 195-92 195h50l106-195L114 72H63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "\\uF001",
    d: "M466 502V0h-60v502h60zm5 145h-70v75h70v-75zM123 0v447H22v55h101v107q0 66 28.5 95.5T244 734q11 0 27-4t30-7v-48q-9 1-17 2.5t-20 1.5q-56 0-68.5-24T183 566v-64h114v-55H183V0h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "\\uF002",
    d: "M125 0v447H24v55h101v107q0 66 28.5 95.5T246 734q11 0 27-4t30-7v-48q-9 1-17 2.5t-20 1.5q-56 0-68.5-24T185 566v-64h114v-55H185V0h-60zm345 0h-60v722h60V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\\u2021",
    d: "M76 487v55h172v180h60V542h172v-55H308V232h172v-55H308V0h-60v177H76v55h172v255H76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\\u2219",
    horizAdvX: 278,
    d: "M179 208H99v86h80v-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\\u201A",
    horizAdvX: 278,
    d: "M205 81l-72-205H81l43 205h81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\\u201E",
    d: "M435 81l-72-205h-52l43 205h81zm-184 0l-72-205h-52l43 205h81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\\u2030",
    horizAdvX: 1000,
    d: "M509 707h53L147-15H91zM86 545q0-47 22-82t67-35q44 0 66.5 35.5T264 545q0 47-22 82t-67 35q-44 0-66.5-35.5T86 545zm303-398q0-47 22-82t67-35q44 0 66.5 35.5T567 147q0 47-22 82t-67 35q-44 0-66.5-35.5T389 147zm-55 0q0 73 37 117.5T478 309t107-44 37-118q0-73-37-117.5T478-15 371 29t-37 118zM31 545q0 73 37 117.5T175 707t107-44 37-118q0-73-37-117.5T175 383 68 427 31 545zm650-398q0 73 37 117.5T825 309t107-44 37-118q0-73-37-117.5T825-15 718 29t-37 118zm55 0q0-47 22-82t67-35q44 0 66.5 35.5T914 147q0 47-22 82t-67 35q-44 0-66.5-35.5T736 147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\\xC2",
    horizAdvX: 667,
    d: "M488 255L332 662 173 255h315zM9 0l286 722h76L659 0h-71l-77 195H152L76 0H9zm289 927h73l99-145h-47l-89 106-90-106h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\\xCA",
    horizAdvX: 611,
    d: "M102 0v722h429v-60H167V403h350v-60H167V60h379V0H102zm168 927h73l99-145h-47l-89 106-90-106h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\\xC1",
    horizAdvX: 667,
    d: "M488 255L332 662 173 255h315zM9 0l286 722h76L659 0h-71l-77 195H152L76 0H9zm444 927L326 784h-44l91 143h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\\xCB",
    horizAdvX: 611,
    d: "M102 0v722h429v-60H167V403h350v-60H167V60h379V0H102zm254 839v88h74v-88h-74zm-174 0v88h74v-88h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\\xC8",
    horizAdvX: 611,
    d: "M102 0v722h429v-60H167V403h350v-60H167V60h379V0H102zm165 927l91-143h-44L187 927h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\\xCD",
    horizAdvX: 278,
    d: "M107 0v725h65V0h-65zm151 927L131 784H87l91 143h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\\xCE",
    horizAdvX: 278,
    d: "M107 0v725h65V0h-65zm-4 927h73l99-145h-47l-89 106-90-106H3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\\xCF",
    horizAdvX: 278,
    d: "M107 0v725h65V0h-65zm82 839v88h74v-88h-74zm-174 0v88h74v-88H15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\\xCC",
    horizAdvX: 278,
    d: "M107 0v725h65V0h-65zm-7 927l91-143h-44L20 927h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\\xD3",
    horizAdvX: 778,
    d: "M389 45q126 0 189 92t63 224-63 224-189 92-189-92-63-224 63-224 189-92zm0-60Q236-15 151.5 86.5T67 361q0 172 84.5 274T389 737t237.5-101.5T711 361q0-172-84.5-274T389-15zm119 942L381 784h-44l91 143h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\\xD4",
    horizAdvX: 778,
    d: "M389 45q126 0 189 92t63 224-63 224-189 92-189-92-63-224 63-224 189-92zm0-60Q236-15 151.5 86.5T67 361q0 172 84.5 274T389 737t237.5-101.5T711 361q0-172-84.5-274T389-15zm-36 942h73l99-145h-47l-89 106-90-106h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "apple",
    unicode: "\\uF000",
    horizAdvX: 790,
    d: "M408 594l-1 7v11q0 61 46 112t116 64v-12l1-18q0-64-50.5-114.5T420 593h-4zm327-397Q679 76 634 29.5T535-17q-25 0-64 16t-60 16q-23 0-64-16t-62-16q-30 0-63 21-13 10-30.5 27.5t-48.5 60T83.5 212 55 360q0 107 61.5 174.5T274 602q16 0 35.5-4t51.5-17 49-13q18 0 61 17t73 17q55 0 97.5-19.5T719 522q-49-31-73.5-70.5T621 362q0-54 30-98t84-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\\xD2",
    horizAdvX: 778,
    d: "M389 45q126 0 189 92t63 224-63 224-189 92-189-92-63-224 63-224 189-92zm0-60Q236-15 151.5 86.5T67 361q0 172 84.5 274T389 737t237.5-101.5T711 361q0-172-84.5-274T389-15zm-39 942l91-143h-44L270 927h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\\xDA",
    horizAdvX: 722,
    d: "M162 722V255q0-97 54.5-153.5T361 45t144.5 56.5T560 255v467h65V254q0-121-68-195T361-15 165 58.5 97 254v468h65zm318 205L353 784h-44l91 143h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\\xDB",
    horizAdvX: 722,
    d: "M162 722V255q0-97 54.5-153.5T361 45t144.5 56.5T560 255v467h65V254q0-121-68-195T361-15 165 58.5 97 254v468h65zm163 205h73l99-145h-47l-89 106-90-106h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\\xD9",
    horizAdvX: 722,
    d: "M162 722V255q0-97 54.5-153.5T361 45t144.5 56.5T560 255v467h65V254q0-121-68-195T361-15 165 58.5 97 254v468h65zm160 205l91-143h-44L242 927h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\\u0131",
    horizAdvX: 222,
    d: "M81 0v502h60V0H81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\\u0302",
    horizAdvX: 278,
    d: "M103 707h73l99-145h-47l-89 106-90-106H3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\\u0303",
    horizAdvX: 278,
    d: "M258 695h19q-9-37-32-61t-59-24q-10 0-20 2.5t-25 8-26.5 8T87 631t-29.5-7.5T40 602H2q8 37 31.5 59T92 683q12 0 18.5-1t11-2 22-6.5T172 665t17-3q37 0 50 33h19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\\u02C9",
    horizAdvX: 278,
    d: "M17 647v60h245v-60H17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\\u02D8",
    horizAdvX: 278,
    d: "M261 707q0-54-33-76t-92-22q-54 0-86.5 23T17 707h19q7-29 36-40.5t64-11.5q37 0 67.5 11.5T243 707h18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\\u02D9",
    horizAdvX: 278,
    d: "M102 619v88h74v-88h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\\u02DA",
    horizAdvX: 278,
    d: "M139 737q36 0 62-26t26-62-26-62-62-26-62 26-26 62 26 62 62 26zm0-33q-22 0-38.5-16.5T84 649q0-20 16.5-37.5T139 594q21 0 38 17t17 38-17 38-38 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\\xB8",
    horizAdvX: 278,
    d: "M35-133q27-10 44.5-15.5T124-158q9-1 22.5 2.5T169-144t9 29q0 19-14 27.5T130-79l-33-3 28 87h23l-15-55q46 0 73.5-13t27.5-54q0-32-29-49t-64-17q-42 0-69 8.5T28-161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\\u02BA",
    d: "M220 707h81L172 566h-47zm131 0h81L303 566h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\\u02DB",
    horizAdvX: 278,
    d: "M246-169q-20-8-58-15t-64-7q-41 0-72.5 23T20-98q0 32 38 60t80 38h53q-52-21-84-44T75-89q0-25 22.5-41t46.5-16q33 0 52.5 4t49.5 16v-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\\u02C7",
    horizAdvX: 278,
    d: "M175 562h-73L3 707h47l89-106 90 106h46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    d: "M100 0v399L6 362v40l94 37v283h65V465l94 37v-40l-94-37V60h363V0H100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    horizAdvX: 222,
    d: "M141 722V472l76 30v-34l-76-31V0H81v413L5 383v34l76 31v274h60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    horizAdvX: 611,
    d: "M273-15q-88 0-151.5 57.5T58 188h70q0-77 50-110t131-33q66 0 120 37t54 102q0 50-30.5 79.5t-134 64-173.5 74T75 542q0 90 68.5 142.5T305 737q89 0 156.5-38.5T540 565h-70q0 61-45.5 86.5T313 677q-64 0-116-32.5T145 551q0-84 105-129 98-37 197-73 106-54 106-159 0-109-78.5-157T273-15zm69 797h-73l-99 145h47l89-106 90 106h46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    horizAdvX: 500,
    d: "M247 517q81 0 132-32t51-107h-65q-4 43-38.5 63.5T241 462q-47 0-80-20t-33-61q0-46 74.5-68.5t136-41 84.5-50 23-72.5q0-80-62-122T235-15q-75 0-132 37.5T46 137h65q0-51 40.5-74T250 40q54 0 92.5 25t38.5 75q0 57-44 71.5t-118.5 32-115 44T63 377q0 72 54 106t130 34zm39 45h-73l-99 145h47l89-106 90 106h46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    d: "M39 0v60l401 602H39v60h478v-60L115 60h402V0H39zm275 782h-73l-99 145h47l89-106 90 106h46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    horizAdvX: 444,
    d: "M40 55l293 392H40v55h364v-55L113 55h291V0H40v55zm218 507h-73L86 707h47l89-106 90 106h46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    horizAdvX: 222,
    d: "M81 175h60v-350H81v350zm0 500h60V325H81v350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    horizAdvX: 722,
    d: "M156 420h216v-45H156V60h146q147 0 216.5 79T588 361q0 155-85.5 228T258 662H156V420zm-65-45H23v45h68v302h195q179 0 275.5-91.5T658 361q0-177-96-269T286 0H91v375z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "glyph234",
    d: "M172 737q45-10 69-19t58-26l93 58 30-28-85-53q70-48 122.5-139T512 268q0-133-60.5-208T278-15 104.5 59.5 44 237t59 178 167 75q77 0 117.5-39.5T448 361l2 2q-7 79-45.5 153.5T289 639l-93-57-29 29 83 51q-22 11-42 18.5T155 697zM278 37q83 0 126 61.5T447 237t-42.5 139T278 438t-126.5-61.5T109 237q0-77 42.5-138.5T278 37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    horizAdvX: 611,
    d: "M274 312L8 722h83l221-349 221 349h70L339 314V0h-65v312zm151 615L298 784h-44l91 143h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    horizAdvX: 500,
    d: "M81 502L250 82l168 420h65L206-192h-66L216 0 8 502h73zm288 205L242 564h-44l91 143h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    horizAdvX: 611,
    d: "M165 219h158q83 0 133 32.5T506 363q0 78-50.5 111T323 507H165V219zm-65 503h65V567h143q121 0 194.5-43T576 363q0-117-74-160.5T308 159H165V0h-65v722z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    d: "M301 40q77 0 110.5 66.5T445 260q0 84-37 143t-116 59q-82 0-122-57t-40-142q0-97 40-160t131-63zM130-192H70v914h60V428l2-2q26 43 72.5 67t99.5 24q104 0 155-77t51-187q0-108-50.5-188T307-15q-54 0-99 24t-76 69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    horizAdvX: 660,
    d: "M80 281h500v-60H80v60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    horizAdvX: 660,
    d: "M117 6L80 42l214 211L80 464l37 38 214-212 212 212 37-38-212-211L580 42 543 6 331 216z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    horizAdvX: 333,
    d: "M176 283v361q-41-36-102-62v45q31 11 55 26.5t49 38.5h49V283h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    horizAdvX: 333,
    d: "M33 283v41q42 34 91 82.5t90 103 41 87.5q0 28-22 45t-59 17q-40 0-64.5-20.5T85 588H37q0 55 39 87t99 32q58 0 96-27.5t38-79.5q0-71-77.5-149.5T113 331h202v-48H33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    horizAdvX: 333,
    d: "M146 524q7-1 12.5-1h7.5q42 0 69 18.5t27 55.5q0 27-25.5 44.5T171 659q-41 0-63-16.5T81 597H27q0 50 41 80t97 30q63 0 107-28t44-84q0-36-26-61t-66-33q45-9 72-37t27-69q0-55-46.5-86.5T169 277q-65 0-106.5 29.5T21 394h54q0-29 27-49t66-20q46 0 73.5 19.5T269 400q0 38-27.5 58T172 478q-6 0-14-1t-12-1v48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    horizAdvX: 834,
    d: "M237 0h-55l417 707h53zm-29 283v361q-41-36-102-62v45q31 11 55 26.5t49 38.5h49V283h-51zM503 0v41q42 34 91 82.5t90 103 41 87.5q0 28-22 45t-59 17q-40 0-64.5-20.5T555 305h-48q0 55 39 87t99 32q58 0 96-27.5t38-79.5q0-71-77.5-149.5T583 48h202V0H503z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    horizAdvX: 834,
    d: "M626 97H414v31l201 287h62V145h63V97h-63V0h-51v97zM237 0h-55l417 707h53zm389 358L484 145h142v213zm-418-75v361q-41-36-102-62v45q31 11 55 26.5t49 38.5h49V283h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    horizAdvX: 834,
    d: "M626 97H414v31l201 287h62V145h63V97h-63V0h-51v97zM237 0h-55l417 707h53zm389 358L484 145h142v213zM146 524q7-1 12.5-1h7.5q42 0 69 18.5t27 55.5q0 27-25.5 44.5T171 659q-41 0-63-16.5T81 597H27q0 50 41 80t97 30q63 0 107-28t44-84q0-36-26-61t-66-33q45-9 72-37t27-69q0-55-46.5-86.5T169 277q-65 0-106.5 29.5T21 394h54q0-29 27-49t66-20q46 0 73.5 19.5T269 400q0 38-27.5 58T172 478q-6 0-14-1t-12-1v48z"
  })))));
}
export default __webpack_public_path__ + "static/UNL.5556c669.svg";
export { SvgUnl as ReactComponent };